export default __webpack_public_path__ + "static/media/doraemon.a012c5a4.jpg";